(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-frosted-glass"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function setupFrostedGlass(section) {
      var wrapper = section.querySelector('.frosted-glass-image-wrapper');
      if (!wrapper) return;
      var blurLayer = wrapper.querySelector('.frosted-glass-blur-layer');
      var blurImage = wrapper.querySelector('.frosted-glass-blur-image');
      var diameter = parseInt(getComputedStyle(blurLayer).getPropertyValue('--clear-diameter')) || 160;
  
      function setMask(x, y, show) {
        if (!show) {
          blurLayer.style.webkitMaskImage = 'none';
          blurLayer.style.maskImage = 'none';
          return;
        }
        var rect = wrapper.getBoundingClientRect();
        var px = x - rect.left;
        var py = y - rect.top;
        var size = diameter;
        var fade = Math.round(size * 0.15);
        var maskImage = `radial-gradient(circle ${size/2}px at ${px}px ${py}px, transparent ${size/2-fade}px, black ${size/2}px)`;
        blurLayer.style.webkitMaskImage = maskImage;
        blurLayer.style.maskImage = maskImage;
      }
  
      function onMove(e) {
        let x, y;
        if (e.touches && e.touches.length) {
          x = e.touches[0].clientX;
          y = e.touches[0].clientY;
        } else {
          x = e.clientX;
          y = e.clientY;
        }
        requestAnimationFrame(() => setMask(x, y, true));
      }
      function onEnter(e) {
        wrapper.style.cursor = 'none';
        onMove(e);
      }
      function onLeave() {
        wrapper.style.cursor = '';
        setMask(0, 0, false);
      }
  
      wrapper.addEventListener('mouseenter', onEnter);
      wrapper.addEventListener('mousemove', onMove);
      wrapper.addEventListener('mouseleave', onLeave);
      wrapper.addEventListener('touchstart', onEnter, {passive: true});
      wrapper.addEventListener('touchmove', function(e) {
        onMove(e);
        e.preventDefault();
      }, {passive: false});
      wrapper.addEventListener('touchend', onLeave, {passive: true});
      wrapper.addEventListener('touchcancel', onLeave, {passive: true});
  
      setMask(0, 0, false);
  
      var img = new window.Image();
      img.onload = function() {
        var ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > 0 && isFinite(ratio)) {
          wrapper.style.aspectRatio = ratio;
        }
      };
      img.src = wrapper.style.backgroundImage.replace(/^url\(["']?|["']?\)$/g, '').replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
  
      // 在 setupFrostedGlass 函数内增加动态设置 background 的逻辑
      if (blurLayer) {
        var hex = getComputedStyle(blurLayer).getPropertyValue('--blur-bg-color').trim();
        var opacity = parseFloat(getComputedStyle(blurLayer).getPropertyValue('--blur-opacity'));
        function hexToRgb(hex) {
          hex = hex.replace('#', '');
          if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
          var bigint = parseInt(hex, 16);
          var r = (bigint >> 16) & 255;
          var g = (bigint >> 8) & 255;
          var b = bigint & 255;
          return [r, g, b];
        }
        var rgb = hexToRgb(hex);
        blurLayer.style.background = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${isNaN(opacity) ? 0.3 : opacity})`;
      }
    }
    function initAll() {
      document.querySelectorAll('.frosted-glass-section').forEach(setupFrostedGlass);
    }
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function(e) {
      setupFrostedGlass(e.target);
    });
    document.addEventListener('shopify:section:select', function(e) {
      setupFrostedGlass(e.target);
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-editor"] && !Shopify.designMode) return;
  try {
    
    $(function(){
     if($(window).width()<767){
       $(".textBox").remove();
     }
    })
    
  } catch(e) { console.error(e); }
})();
})();
